<section class="new-login-section">
    <div class="container " id="container">
        <div class="form-container sign-up-container">
            <div class="mobilebanner">
                <div class="mobile-back-btn" onclick="history.back()" >
                    <i class="pi pi-chevron-circle-left "> </i> Back
                    
                </div>
                <img src="assets/img/login/login-banner2.png" alt="">
            </div>
            <!-- <img src="assets/img/icon/tennis-ball.png" alt="" class="tennsi-ball"> -->
            <div class="steps-1 signup-steps " *ngIf="steps1">
                <form [formGroup]="signUpForm" *ngIf="this.signUpForm" (ngSubmit)="onSignupSubmit()">
                    <div class="heading-div mb-3">
                        <h1>Register</h1>
                    </div>
                    <!-- <span class="p-float-label w-100">
                    <input pInputText id="username" [(ngModel)]="value" />
                    <label htmlFor="username">Enter Mobile Number</label>
                </span> -->
                    <span class="w-100">
                        <label for="phoneNumber" class="w-100 text-left">Enter your mobile number for verification</label>
                        <div class="mobile0numberField">
                            <p-inputNumber id="phoneNumber" mode="decimal" [useGrouping]="false"
                            formControlName="mobileNumber" [maxlength]="10" placeholder="Eg.  1234567890"
                            [ngClass]="{ 'is-invalid': ((signupFormSubmitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))}"
                            required>
                        </p-inputNumber>
                        <div class="number-code">
                            <span>+91</span>
                        </div>
                        </div>
                      

                    </span>
                    <div *ngIf="((signupFormSubmitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.mobileNumber.errors.required">Mobile Number is required</div>
                        <div *ngIf="!f.mobileNumber.errors.required">
                            Please enter valid 10 digit mobile number.
                        </div>
                    </div>
                    <div *ngIf="showMessage" class=" invalid-feedback" role="">
                        {{message}}
                    </div>
                    
                    <!-- <div class="referal-code-div" *ngIf="refferalcodeAvailable" >
                        Have Referral Code?
                    </div> -->
                    <!-- <div class="referal-code-div" *ngIf="refferalcodeAvailable" (click)="showDialog('bottom')" >
                        Have Referral Code?
                    </div> -->
                    <div class="referal-code-availabel"  *ngIf="refferalcodenotAvailable">
                        <span>Referral Code: 8HKkdmTsv</span> <span class="close-icon" (click)="removeReferalcode()" ><i class='bx bx-x'></i></span>
                    </div>
                    <div class="user-list">
                        <span class="p-float-label w-100">
                            <div class="text-left lable-div">Sign up as a </div>
                        </span>
                        <ul>
                            <li *ngFor="let userCategory of userCategories"
                                [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                    <div class="box">
                                        <div class="role-lis-details">
                                            <!-- <div class="Player icon">
                                                <img src="../../../../assets/img/players/role1.svg" alt=""
                                                    class="image-role-player">
                                                <img src="../../../../assets/img/players/role2.svg" alt=""
                                                    class="image-role-coach">
                                                <img src="../../../../assets/img/players/role3.svg" alt=""
                                                    class="image-role-proplayer">
                                            </div> -->

                                            <div class="user-name"> {{userCategory.name}} </div>
                                        </div>
                                        <p-radioButton formControlName="{{userCategory.slug}}"
                                            [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                            (onClick)="onUserCategorySelect(userCategory, $event)">
                                        </p-radioButton>
                                    </div>
                                </label>

                            </li>

                        </ul>
                        <!-- <div class="user-icons-list" *ngFor="let userCategory of userCategories">
                            <div class="role-lis-details">
                                <p-radioButton formControlName="{{userCategory.slug}}" [value]="userCategory.status"
                                    (onClick)="onUserCategorySelect(userCategory, $event)">
                                </p-radioButton>
                                <div class="user-name">
                                    {{userCategory.name}}
                                </div>
                            </div>
                        </div> -->
                        <div *ngIf="showCategoryError">
                            <div>
                                <span> Please Select User Category</span>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-12 regitser-button continue-btn">
                        <button type="submit">Send OTP</button>
                    </div>
                    <div class="register-btn-div">
                        Already have an account? <a (click)="onSignInClick()">Login</a>
                    </div>
                </form>

            </div>
            <!-- <span class="p-float-label w-100">
                <input pInputText type="password" id="username" [(ngModel)]="value" />
                <label htmlFor="username">Password</label>
            </span> -->
            <!-- <a href="#">Forgot your password?</a>
			<button>Sign In</button> -->
            <form action="" *ngIf="steps2" class="mobie-verification-div">
                <div class="col-md-12 steps-2" *ngIf="steps2">

                    <div class=" justify-content-center">
                        <div class="col-12 col-md-6 col-lg-4" style="min-width: 100%;">
                            <div class="card bg-white mb-5 mt-5 border-0" style="box-shadow: none;">
                                <div class="card-body p-0 text-center">
                                    <h4>Verify</h4>
                                    <p class="sent-otp-mobile-msg">Your code was sent to you via text message on {{mobileNumber}}</p>
                                    <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                        <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                                            [config]="config">
                                        </ng-otp-input>
                                        <div *ngIf="showOtpErrors && !showOtpErrorsMsg">
                                            <span style="color: red;">Please enter OTP.</span>
                                        </div>
                                        <div *ngIf="showOtpErrorsMsg">
                                            <span style="color: red;">{{otpErrorMessage}}</span>
                                        </div>
                                        <div id="timer-btn-otp" >
                                            <span  *ngIf="!showResendButton">{{transform(counter)}}</span>
                                            <span *ngIf="showResendButton">
                                                <div >
                                                    <a (click)="resendOtp()"
                                                        style="text-decoration: underline;cursor: pointer; color: #fff;">Resend</a>
                                                </div>
                                            </span>
                                        </div>

                                    </div>
                                    <!-- <p class="resend text-muted mb-0">
                                    You enter wrong number? <a (click)="backOtpForm()">Resend</a>
                                  </p> -->
                                </div>
                                <div id="login-submit">
                                    <button type="submit" class="btn btn-primary mb-3" (click)="onClickOtpSubmit()">
                                        Verify </button>

                                </div>
                                <p class="resend text-muted mb-0"> Do you want to change the number? <a
                                        (click)="onClickSignUpOtpBack()">Change number</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="col-md-12 steps-3 profile-details-steps" *ngIf="steps3">
                <form [formGroup]="signUpForm2" *ngIf="this.signUpForm2" (ngSubmit)="onSignupSubmit2()">
                    <div class="heading-div">
                        <h1>Profile Details</h1>
                        <span>Enter your basic information
                        </span>
                    </div>
                    <div class="p-fluid grid profile-details-div">
                        <div class="field col-6 md:col-4">
                            <span class="">
                                <label for="inputtext-left">First Name</label>
                                <!-- <i class="pi pi-user"></i> -->
                                <input pInputText type="text" id="fisrt-name" formControlName="firstName" placeholder="Enter First Name "
                                    class="form-control textCapital " required
                                    [ngClass]="{ 'is-invalid':((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))}">

                      
                            </span>
                            <div *ngIf="((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="signupF.firstName.errors.required">First Name is required</div>
                                <div *ngIf="!signupF.firstName.errors.required">
                                    Only Alphabets allowed.
                                </div>
                            </div>
                        </div>
                        <div class="field col-6 md:col-4">
                            <span class="">
                                <label for="last-name">Last Name</label>
                                <!-- <i class="pi pi-user"></i> -->
                                <input pInputText type="text" formControlName="lastName" placeholder="Enter Last Name "
                                    class="form-control textCapital" id="last-name" required
                                    [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))}">

                               
                            </span>
                            <div *ngIf="((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="signupF.lastName.errors.required">Last name is required</div>
                                <div *ngIf="!signupF.lastName.errors.required">
                                    Only
                                    Alphabets allowed.</div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <span class="">
                                <label for="email-address">Email Address</label>
                                <!-- <i class="pi pi-envelope"></i> -->
                                <input type="email" formControlName="email" class="form-control" id="email-address" placeholder="Enter Email Address "
                                    pInputText
                                    [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched))) }">
                                

                              

                            </span>
                            <div *ngIf="((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched)))"
                                class="invalid-feedback" style="margin-top: 0px!important;">
                                <div *ngIf="signupF.email.errors.required">Email is required</div>
                                <div *ngIf="!signupF.email.errors.required && signupF.email.errors.email">
                                    Enter valid email address.
                                </div>
                            </div>
                            <div *ngIf="showMessage" class="invalid-feedback" role="">
                                {{message}}
                            </div>

                        </div>
                        <!-- <div class="refrel code col-12 ">
                            <div class="qst">Do you have Referral Code ?</div>
                            <div class="flex align-items-center">
                                <div class="questin-opt" (click)="showDiv = false">
                                    <p-radioButton formControlName="referralYes" inputId=" ingredient1"></p-radioButton>
                                    <label for="ingredient1" class="ml-2">No</label>
                                </div>
                                <div class="questin-opt" (click)="showDiv = true">
                                    <p-radioButton formControlName="referralNo" inputId="ingredient2"></p-radioButton>
                                    <label for="ingredient2" class="ml-2">Yes</label>
                                </div>
                            </div>
                        </div> -->
                        <!-- *ngIf="showDiv" -->
                        <div class="field col-12 md:col-4 referral-div" >
                            <span class="">
                                <label for="referral-code">Referral Code</label>
                                <input id="referral-code" type="text" formControlName="referral" class="form-control" style=" margin-top: 0px!important;" placeholder="Enter Referral Code"
                                    pInputText>
                              
                            </span>
                        </div>
                   
                        <div class="col-md-12 regitser-button">
                            <button type="submit">Register</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="form-container sign-in-container " *ngIf="!showForgotPasswordForm">
            <div class="mobilebanner" [ngClass]="{'mobile-keyboard-open': keyboardOpen}">
                <div class="mobile-back-btn"  onclick="history.back()">
                    <i class="pi pi-chevron-circle-left "> </i> Back
                </div>
                <img src="assets/img/login/login1.png" alt="">
            </div>
            <div class="sign-in-div">
                <div class="heading-div">
                    <h1>Login</h1>
                    <!-- <div class="social-container">
                    <a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
                    <a href="#" class="social"><i class="fab fa-google-plus-g"></i></a>
                    <a href="#" class="social"><i class="fab fa-linkedin-in"></i></a>
                </div> -->
                    <span>Please enter your credentials to access your account. </span>
                </div>
                <div class="col-md-12 p-p-0">
                    <div *ngIf="!showMobileLoginOtpForm" class="col-md-12 p-p-0">
                        <form class="login-form" [formGroup]="mobileLoginForm" *ngIf="this.mobileLoginForm"
                            (ngSubmit)="onMobilePhoneSubmit('')">
                            <div class="Phone form-lable ">
                                <span class=" w-100">
                                    <label for="inputtext-left">Phone Number <span
                                        class="mandatory-fields">*</span></label>
                                        <div class="mobile0numberField">
                                            <p-inputNumber [useGrouping]="false" id="inputtext-left" p
                                            formControlName="mobileNumber" [maxlength]="10" placeholder="Eg. 1234567890"
                                            [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                            required>
                                        </p-inputNumber>
                                        <div class="number-code"><span>+91</span></div>
                                        </div>
                                </span>
                            </div>
                            <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                class="invalid-feedback">
                                <div *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                    Mobile number is required.
                                </div>
                                <div *ngIf="!mobNumberFormValidation.mobileNumber.errors.required">
                                    Please enter a valid 10 digit mobile number.
                                </div>
                            </div>
                            <div class="invalidmobile invalid-feedback" *ngIf="showMobileFormErrors">
                                {{mobileFormsErrors}}
                            </div>
                            <div id="login-submit">
                                <button class="mt-3" type="submit">Send OTP <i class="pi pi-send "></i></button>
                            </div>
                        </form>
                        <div class="register-btn-div">
                            New user? <a (click)="onSignUpClick()">Register</a>
                        </div>
                    </div>
                    <div *ngIf="showMobileLoginOtpForm" class="col-md-12 otp-section">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="position-relative mb-3">
                                <h4>VERIFY DETAILS </h4>
                                <p>OTP sent to {{mobileNumber}}</p>
                                <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                        [config]="config">
                                    </ng-otp-input>

                                    <div style="display: block;">
                                        <div *ngIf="showOtpErrors">
                                            <span style="color: red;">Please enter valid OTP.</span>
                                        </div>
                                        <div *ngIf="showOtpLoginErrors">
                                            <span style="color: red;">{{otpLoginErrors}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div id="timer-btn-otp">
                                    <span *ngIf="!showResendButton" >{{displayTime}}
                                        {{transform(counter)}}</span>
                                    <span *ngIf="showResendButton">
                                        <div >
                                            <a (click)="resendOtp()"
                                                style="text-decoration: underline;cursor: pointer;">Resend</a>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div id="login-submit">
                            <button type="submit" (click)="onClickOtpLoginSubmit()" value="Submit">
                                Verify
                            </button>

                        </div>
                        <p class="resend text-muted mb-0 mt-3 text-center"> Do you want to change the number? <a
                                style="cursor:pointer" (click)="onClickOtpback()">Change number</a></p>


                    </div>
                </div>
                <!-- <p-tabView>
                    <p-tabPanel header="Login With OTP">
                       
                    </p-tabPanel>
                    <p-tabPanel header="Login With Password">
                        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">

                            <div class="name form-lable">
                                <span class=" w-100">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" formControlName="email" pInputText placeholder="Email Address"
                                        [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.email.errors }"
                                        required>
                                </span>
                            </div>
                            <div *ngIf="loginFormSubmitted && loginf.email.errors" class="invalid-feedback">
                                <div *ngIf="loginf.email.errors.required">Email is required</div>
                                <div *ngIf="loginf.email.errors.email">Enter valid email address
                                </div>
                            </div>
                            <div class="pwd form-lable">
                                <span class="w-100">
                                    <label htmlFor="password_login">Password</label>
                                    <p-password [toggleMask]="true" id="password_login" formControlName="password"  placeholder="Password"
                                        [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.password.errors }"
                                        autocomplete="on" required>
                                    </p-password>
                                   
                                    

                                </span>
                            </div>
                            <div *ngIf="loginFormSubmitted && loginf.password.errors" class="invalid-feedback">
                                <div *ngIf="loginf.password.errors.required">Password is required
                                </div>
                                <div *ngIf="loginf.password.errors.minlength">Password must be at
                                    least 6
                                    characters
                                </div>
                            </div>
                            <div class="col-md-12 input-form">
                            </div>
                            <div class="col-md-12 input-form mobile-p-none">
                                <div *ngIf="isLoginFailed" class="alert alert-danger" role="alert">
                                    {{errorMessage}}
                                </div>
                            </div>
                            <div class="forgot-p">
                                <label for="rememberMe">
                                    <div class="forms">
                                        <p-checkbox formControlName="rememberMe" binary="true"
                                            inputId="rememberMe"></p-checkbox>
                                        <span>Remember me</span>
                                    </div>
                                </label>
                                <label for="forgot-password_login"> <a (click)="onClickForgotPassword()">
                                        Forgot
                                        Password</a></label>
                            </div>
                            <div id="login-submit" class="otp-submit">
                                <button type="submit" value="Sign In">Login</button>

                            </div>
                        </form>
                        <div class="register-btn-div">
                            Don't have an account? <a (click)="onSignUpClick()">Register</a>
                        </div>
                    </p-tabPanel>
                </p-tabView> -->
            </div>

        </div>
        <div class="col-md-12 form-container sign-in-container forgot-password-container" *ngIf="showForgotPasswordForm">
            <div class="mobilebanner" [ngClass]="{'mobile-keyboard-open': keyboardOpen}">
                <!-- <div class="mobile-back-btn" (click)="onSignInClick()">
                    <i class="pi pi-chevron-circle-left "> </i>
                </div> -->
                <img src="assets/img/login/login2.png" alt="">
            </div>
            <div class="sign-in-div forgot-p-div">
                <form [formGroup]="forgotPassForm">
                    <div class="row m-0 w-100">
                        <div class="col-lg-12">
                            <h4>
                                Forgot Password
                            </h4>
                            <div class="style-form-group forgot-password-div form-lable">
                                <div class="name form-lable">
                                    <span class=" w-100">
                                        <label htmlFor="email">Email</label>
                                        <input type="email" id="email" formControlName="email" pInputText placeholder="Enter Email Address"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                    </span>
                                    <div *ngIf="submitted && forgotPassValidation.email.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forgotPassValidation.email.errors.required">
                                            Email is required.
                                        </div>
                                        <div *ngIf="forgotPassValidation.email.errors.pattern">
                                            Please enter a valid email id.
                                        </div>
                                    </div>
                                    <div *ngIf="successMessage" style="color:green;">
                                        {{successMessage.message}}
                                    </div>
                                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                    <div class="button pt-2 pt-lg-3 forgot-password-div ">
                        <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                        &nbsp;&nbsp;
                        <button class="forgot-pass-submit" (click)="onForgotPassSubmit()">Submit</button>
                    </div>
                </form>
            </div>

        </div>
        <div id="overlay_container" class="">
            <div class="overlay">
                <div class="overlay-panel overlay-left">
                    <div class="desktop-banners"> 
                        <img src="assets/img/login/login-banner2.png" alt="">
                    </div>
                    <div class="text-div">
                        <h1>Welcome Back To TPL!</h1>
                        <p>Please enter your credentials to access your account. </p>
                        <button class="ghost" id="signIn" (click)="onSignInClick()">Login</button>
                    </div>
                   
                </div>
                <div class="overlay-panel overlay-right">
                    <div class="desktop-banners"> 
                        <img src="assets/img/login/login-banner2.png" alt="">
                    </div>
                   <div class="text-div">
                    <h1>Join TPL and Elevate Your Tennis Experience!
                    </h1>
                    <p>Register now to enjoy exclusive access to premium tennis content and community features.
                    </p>
                    <button class="ghost" id="signUp" (click)="onSignUpClick()">Register</button>
                   </div>
                </div>
            </div>
        </div>
    </div>
</section>

<p-dialog header=" Referral Code" [(visible)]="referalModal" [position]="position" [style]="{ width: '100%' }" id="refeeral_code">
    <div class="field col-12 md:col-4 referral-div">
        <span class="">
            
            <input id="referral-code" type="text" formControlName="referral" class="form-control" placeholder="Enter Referral Code"
                pInputText>
            
        </span>
    </div>

    <div class="APL-btn">
       <button (click)="referalCode()">Apply Referral Code</button> 
    </div>

</p-dialog>